import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 5,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 3,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

function CarouselItem({ name, imgSrc, text }) {
    return <div className="blurp">
        <div className="blurp-name">{name}</div>
        <div className="blurp-text">{text}</div>
        <img className="blurp-img" src={imgSrc} alt="" />
    </div>;
}

function BlurpCarousel() {
    const [carouselItems, setCarouselItems] = useState([]);

    useEffect(() => {
        const apiEndpoint = `${process.env.REACT_APP_API_BASE_URL}/blurps`;

        axios.get(apiEndpoint)
            .then(response => setCarouselItems(response.data))
            .catch(error => console.error('Error fetching carousel items:', error));
    }, []);

    return (
        <div id="carousel" className="container-xxl py-5 section">
            <h2 className="text-secondary text-uppercase">Blurpy</h2>
            <div className="container">
                <Carousel
                    swipeable={true}
                    draggable={false}
                    showDots={false}
                    centerMode={false}
                    responsive={responsive}
                    ssr={false} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={3000}
                    keyBoardControl={true}
                    //customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile"]}
                    dotListClass="custom-dot-list-style"
                    itemClass="carousel-item-padding-40-px"
                >
                    {carouselItems.map((item, index) => (
                        <CarouselItem key={item.id} imgSrc={process.env.REACT_APP_API_BASE_URL + "/" + item.imagePath} name={item.name} text={item.text} />
                    ))}
                    </Carousel>
            </div>
        </div>
    );
}

export default BlurpCarousel;

